import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import PlanSelect from '../screens/PlanSelect/PlanSelect'
import { AllPlans } from '../screens/AllPlans/AllPlans'
import { CheckoutScreen } from '../screens/Checkout/Checkout'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { PaywallScreen } from 'stores/PaywallStore'
import { Spinner } from 'common/Spinner/Spinner'
import { useSession } from 'hooks/useSession'
import { Success } from '../screens/Success/Success'

interface PaywallDrawerProps extends DrawerProps {}

export const PaywallDrawer = observer((props: PaywallDrawerProps) => {
  const { paywallStore, drawersStore } = useRootStore()
  const workspace = useCurrentWorkspace()
  const { logout } = useSession()

  useEffect(() => {
    if (workspace) {
      paywallStore.ensureInitialized(workspace.id)
    }
  }, [workspace, paywallStore])

  const handleLogout = () => {
    paywallStore.reset()
    drawersStore.closeDrawer()
    logout()
  }

  // Loading state
  if (paywallStore.isLoading) {
    return (
      <Drawer.Root {...props}>
        <Drawer.Portal>
          <Drawer.Content>
            <Drawer.InnerContent isSnappedTop>
              <Drawer.Container padding="0px">
                <Spinner />
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
          <Drawer.Overlay />
        </Drawer.Portal>
      </Drawer.Root>
    )
  }

  // Screen rendering
  const renderScreen = () => {
    switch (paywallStore.currentScreen) {
      case PaywallScreen.PLAN_SELECT:
        return <PlanSelect onLogout={handleLogout} key="planSelect" />
      case PaywallScreen.ALL_PLANS:
        return <AllPlans key="allPlans" />
      case PaywallScreen.CHECKOUT:
        return <CheckoutScreen key="checkout" />
      case PaywallScreen.SUCCESS:
        return <Success key="success" />
      default:
        return <div> </div>
    }
  }

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight={paywallStore.isFullHeight}>
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Container padding="0px">{renderScreen()}</Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
